const ROLE_ORDER = ["Duelist", "Controller", "Initiator", "Sentinel"];

const ROLE_NAMES = {
    Duelist: "决斗者",
    Controller: "控场",
    Initiator: "先锋",
    Sentinel: "守护者",
};

const ROLE_ICONS = {
    Duelist: "https://image.gamersky.com/webimg13/valorant_track/role-duelist.7dc0ccab.svg",
    Controller: "https://image.gamersky.com/webimg13/valorant_track/role-controller.2bbc8e86.svg",
    Initiator: "https://image.gamersky.com/webimg13/valorant_track/role-initiator.79191ea9.svg",
    Sentinel: "https://image.gamersky.com/webimg13/valorant_track/role-sentinel.04642661.svg",
};

const GAMERSKY_AGENT_IMAGE_ROOT = "https://image.gamersky.com/webimg13/valorant_track/hero/";

const AGENT_IMAGE_DEFINITIONS = [
    ["Astra", "Rift", "41fb69c1-4189-7b37-f117-bcaf1e96f1bf"],
    ["Breach", "Breach", "5f8d3a7f-467b-97f3-062c-13acf203c006"],
    ["Brimstone", "Sarge", "9f0d8ba9-4140-b941-57d3-a7ad57c6b417"],
    ["Chamber", "Deadeye", "22697a3d-45bf-8dd7-4fec-84a9e28c69d7"],
    ["Clove", "Smonk", "1dbf2edd-4729-0984-3115-daa5eed44993"],
    ["Cypher", "Gumshoe", "117ed9e3-49f3-6512-3ccf-0cada7e3823b"],
    ["Deadlock", "Cable", "cc8b64c8-4b25-4ff9-6e7f-37b4da43d235"],
    ["Fade", "BountyHunter", "dade69b4-4f5a-8528-247b-219e5a1facd6"],
    ["Gekko", "Aggrobot", "e370fa57-4757-3604-3648-499e1f642d3f"],
    ["Harbor", "Mage", "95b78ed7-4637-86d9-7e41-71ba8c293152"],
    ["Iso", "Sequoia", "0e38b510-41a8-5780-5e8f-568b2a4f2d6c"],
    ["Jett", "Wushu", "add6443a-41bd-e414-f6ad-e58d267f4e95"],
    ["KAY_O", "Grenadier", "601dbbe7-43ce-be57-2a40-4abd24953621"],
    ["Killjoy", "Killjoy", "1e58de9c-4950-5125-93e9-a0aee9f98746"],
    ["Miks", "Iris", "7c8a4701-4de6-9355-b254-e09bc2a34b72"],
    ["Neon", "Sprinter", "bb2a4828-46eb-8cd1-e765-15848195d751"],
    ["Omen", "Wraith", "8e253930-4c05-31dd-1b6c-968525494517"],
    ["Phoenix", "Phoenix", "eb93336a-449b-9c1b-0a54-a891f7921d69"],
    ["Raze", "Clay", "f94c3b30-42be-e959-889c-5aa313dba261"],
    ["Reyna", "Vampire", "a3bfb853-43b2-7238-a4f1-ad90e9e46bcc"],
    ["Sage", "Thorne", "569fdd95-4d10-43ab-ca70-79becc718b46"],
    ["Skye", "Guide", "6f2a04ca-43e0-be17-7f36-b3908627744d"],
    ["Sova", "Hunter", "320b2a48-4d9b-a075-30f1-1f93a9b638fa"],
    ["Tejo", "Cashew", "b444168c-4e35-8076-db47-ef9bf368f384"],
    ["Veto", "Pine", "92eeef5d-43b5-1d4a-8d03-b3927a09034b"],
    ["Viper", "Pandemic", "707eab51-4836-f488-046a-cda6bf494859"],
    ["Vyse", "Nox", "efba5359-4016-a1e5-7626-b1ae76895940"],
    ["Waylay", "Terra", "df1cb487-4902-002e-5c17-d28e83e78588"],
    ["Yoru", "Stealth", "7f94d92c-4234-0a36-9646-3a87eb8b5c89"],
];

const AGENT_IMAGE_LOOKUP = AGENT_IMAGE_DEFINITIONS.reduce((lookup, definition) => {
    const [fileName, ...aliases] = definition;
    for (const alias of [fileName, ...aliases]) lookup[String(alias).toLowerCase()] = fileName;
    return lookup;
}, Object.create(null));

const AGENT_NAMES = {
    Astra: "星礈",
    Breach: "铁臂",
    Brimstone: "炼狱",
    Chamber: "尚勃勒",
    Clove: "幻棱",
    Cypher: "零",
    Deadlock: "钢锁",
    Fade: "黑梦",
    Gekko: "盖可",
    Harbor: "海神",
    Iso: "壹决",
    Jett: "捷风",
    KAY_O: "K/O",
    Killjoy: "奇乐",
    Miks: "迷核",
    Neon: "霓虹",
    Omen: "幽影",
    Phoenix: "不死鸟",
    Raze: "雷兹",
    Reyna: "芮娜",
    Sage: "贤者",
    Skye: "斯凯",
    Sova: "猎枭",
    Tejo: "钛狐",
    Viper: "蝰蛇",
    Veto: "禁灭",
    Vyse: "维斯",
    Waylay: "钨月",
    Yoru: "夜露",
};

const WEAPON_NAMES = {
    Ares: "战神",
    Bandit: "强盗",
    Bucky: "雄鹿",
    Bulldog: "獠犬",
    Classic: "标配",
    Frenzy: "狂怒",
    Ghost: "鬼魅",
    Guardian: "戍卫",
    Headhunter: "猎头",
    Judge: "判官",
    Marshal: "飞将",
    Melee: "近战武器",
    Odin: "奥丁",
    Operator: "冥驹",
    Outlaw: "莽侠",
    Phantom: "幻影",
    Sheriff: "正义",
    Shorty: "短炮",
    Spectre: "骇灵",
    Stinger: "蜂刺",
    Vandal: "狂徒",
};

const TAG_DEFINITIONS = [
    { key: "kills3k", name: "3k", caption: "3杀" },
    { key: "kills4k", name: "4k", caption: "4杀" },
    { key: "kills5k", name: "Ace", caption: "5杀" },
    { key: "highKast", name: "High KAST", caption: "高KAST" },
    { key: "victim", name: "Victim", caption: "受害者" },
    { key: "clutch1v1", name: "1v1 Clutch", caption: "1V1胜", hidden: true },
    { key: "clutch1v2", name: "1v2 Clutch", caption: "1V2胜" },
    { key: "clutch1v3", name: "1v3 Clutch", caption: "1V3胜" },
    { key: "clutch1v4", name: "1v4 Clutch", caption: "1V4胜" },
    { key: "clutch1v5", name: "1v5 Clutch", caption: "1V5胜" },
    { key: "clutchLost1v1", name: "1v1 Lost", caption: "1V1负", hidden: true },
    { key: "clutchLost1v2", name: "1v2 Lost", caption: "1V2负" },
    { key: "clutchLost1v3", name: "1v3 Lost", caption: "1V3负" },
    { key: "clutchLost1v4", name: "1v4 Lost", caption: "1V4负" },
    { key: "clutchLost1v5", name: "1v5 Lost", caption: "1V5负" },
];

const TAG_LOOKUP = TAG_DEFINITIONS.reduce((lookup, definition) => {
    for (const value of [definition.key, definition.name, definition.caption]) {
        lookup[value.toLowerCase()] = definition;
    }
    return lookup;
}, Object.create(null));

function isPresent(value) {
    return value !== null && value !== undefined && value !== "";
}

function toNumber(value) {
    if (!isPresent(value)) {
        return null;
    }
    const result = Number(value);
    return Number.isFinite(result) ? result : null;
}

function normalizedDigits(digits) {
    if (digits === undefined) {
        return 1;
    }
    return Math.max(0, Math.min(2, Number(digits) || 0));
}

function formatDecimal(value, digits) {
    return formatFixedDecimal(value, digits);
}

function formatFixedDecimal(value, digits) {
    const number = toNumber(value);
    if (number === null) {
        return "-";
    }
    return number.toFixed(normalizedDigits(digits));
}

function formatPercent(value, digits) {
    const number = toNumber(value);
    return number === null ? "-" : `${number.toFixed(normalizedDigits(digits))}%`;
}

function formatInteger(value) {
    const number = toNumber(value);
    return number === null ? "-" : String(Math.round(number));
}

function sectionData(section) {
    return section && Array.isArray(section.data) ? section.data : [];
}

function formatDisplayValue(value, digits) {
    if (!isPresent(value)) {
        return "-";
    }
    const text = String(value).trim();
    const match = text.match(/^([+-]?(?:\d+(?:\.\d+)?|\.\d+))(%?)$/);
    if (!match) {
        return text;
    }
    const number = toNumber(match[1]);
    return number === null ? text : `${number.toFixed(normalizedDigits(digits))}${match[2]}`;
}

function formatPlayTime(value) {
    if (!isPresent(value)) {
        return "-";
    }
    const text = String(value).trim();
    if (!/^\d+(?:\.\d+)?$/.test(text)) {
        return text;
    }
    const seconds = Number(text);
    if (!Number.isFinite(seconds) || seconds < 0) {
        return text;
    }
    return seconds < 3600
        ? `${Math.floor(seconds / 60)}m`
        : `${Math.floor(seconds / 3600)}h`;
}

function localizeRole(name) {
    return ROLE_NAMES[name] || name || "-";
}

function roleIcon(name, fallback) {
    return ROLE_ICONS[name] || fallback || "";
}

function localizeAgent(name, matchNameMap) {
    const canonicalName = normalizeAgentImageName(name);
    return AGENT_NAMES[canonicalName]
        || (matchNameMap && (matchNameMap[name] || matchNameMap[canonicalName]))
        || name
        || "-";
}

function normalizeAgentImageName(name) {
    const value = String(name || "").trim().replace(/\//g, "_");
    return AGENT_IMAGE_LOOKUP[value.toLowerCase()] || value;
}

function gamerskyAgentImage(name) {
    const fileName = normalizeAgentImageName(name);
    return fileName ? `${GAMERSKY_AGENT_IMAGE_ROOT}${encodeURIComponent(fileName)}.png` : "";
}

function localizeWeapon(name) {
    return WEAPON_NAMES[name] || name || "-";
}

function tagDefinition(tag) {
    if (!tag) return null;
    return TAG_LOOKUP[String(tag.key || "").trim().toLowerCase()]
        || TAG_LOOKUP[String(tag.name || "").trim().toLowerCase()]
        || null;
}

function localizeTag(tag) {
    if (!tag) {
        return "";
    }
    const definition = tagDefinition(tag);
    if (definition) return definition.caption;
    const rawName = tag.name || tag.key || "";
    const killMatch = String(rawName).match(/^(\d)k$/i);
    return killMatch ? `${killMatch[1]}杀` : rawName;
}

function weaponProgress(kills, leadingKills) {
    const value = toNumber(kills);
    const maximum = toNumber(leadingKills);
    if (value === null || value <= 0 || maximum === null || maximum <= 0) {
        return 0;
    }
    return Math.min(100, (value / maximum) * 100);
}

function normalizeRoles(roles) {
    const source = Array.isArray(roles) ? roles : [];
    return ROLE_ORDER.map(name => {
        const role = source.find(item => item && String(item.name).toLowerCase() === name.toLowerCase());
        const hasData = role && ["matches", "wins", "losses", "winRate", "kda"]
            .some(key => toNumber(role[key]) !== null);
        return hasData
            ? { ...role, name, missing: false }
            : { id: `missing-${name}`, name, imageUrl: "", missing: true };
    });
}

function matchDetails(match) {
    return match && match.recordDetails ? match.recordDetails : {};
}

function visibleMatchTags(match) {
    const tags = matchDetails(match).tags;
    return Array.isArray(tags) ? tags.filter(tag => {
        const definition = tagDefinition(tag);
        return !definition || !definition.hidden;
    }) : [];
}

function matchTags(match) {
    return visibleMatchTags(match).slice(0, 2);
}

function hasMoreTags(match) {
    return visibleMatchTags(match).length > 2;
}

function tagClass(tag) {
    const tone = tag && String(tag.tone).toLowerCase();
    if (tone === "negative") return "negative";
    if (tone === "positive") return "positive";
    return "neutral";
}

function matchResult(match) {
    const explicit = match && match.recordDetails && match.recordDetails.result;
    if (explicit === "victory" || explicit === "win") {
        return "win";
    }
    if (explicit === "defeat" || explicit === "loss") {
        return "loss";
    }
    const selfScore = toNumber(match && match.selfScore);
    const enemyScore = toNumber(match && match.enemyScore);
    if (selfScore === null || enemyScore === null || selfScore === enemyScore) {
        return "tie";
    }
    return selfScore > enemyScore ? "win" : "loss";
}

function positionText(position) {
    const value = Number(position);
    if (value === 1) return "MVP";
    if (value === 2) return "2nd";
    if (value === 3) return "3rd";
    if (!Number.isFinite(value)) return "-";
    return `${value}th`;
}

module.exports = {
    formatDecimal,
    formatDisplayValue,
    formatFixedDecimal,
    formatInteger,
    formatPlayTime,
    formatPercent,
    gamerskyAgentImage,
    hasMoreTags,
    localizeAgent,
    localizeRole,
    localizeTag,
    localizeWeapon,
    matchResult,
    matchTags,
    normalizeRoles,
    positionText,
    roleIcon,
    sectionData,
    tagClass,
    toNumber,
    weaponProgress,
};
